import tinymce from "tinymce";
import "tinymce/models/dom/model.min"
import "tinymce/icons/default/icons.min"
import "tinymce/themes/silver/theme.min"

export class TextEditor extends HTMLTextAreaElement {

    connectedCallback() {
        this.textarea = tinymce.init({
            selector: 'textarea#' + this.id,
            license_key: 'gpl',
            promotion: false,
            language: "fr_FR",
            base_url: "/vendors/tiny",
            // tools
            plugins: 'preview searchreplace autolink directionality table wordcount help charmap quickbars',
            menubar: 'edit view insert table help',
            toolbar: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent',
            contextmenu: 'link image table',
            quickbars_selection_toolbar: "bold italic underline strikethrough",
            quickbars_insert_toolbar: false,
            toolbar_sticky: false,
        });
    }

    disconnectedCallback() {
        tinymce.remove()
    }
}

export class TextEditorFull extends HTMLTextAreaElement {

    connectedCallback() {
        this.textarea = tinymce.init({
            selector: 'textarea#' + this.id,
            license_key: 'gpl',
            promotion: false,
            language: "fr_FR",
            base_url: "/vendors/tiny",
            // tools
            plugins: 'preview searchreplace autolink directionality table wordcount help charmap quickbars lists anchor',
            menubar: 'edit view insert table help',
            toolbar: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | link anchor | ltr rtl',
            contextmenu: 'link image table',
            quickbars_selection_toolbar: "bold italic underline strikethrough",
            quickbars_insert_toolbar: false,
            toolbar_sticky: false,
        });
    }

    disconnectedCallback() {
        tinymce.remove()
    }
}

